module.exports = __webpack_public_path__ + "img/keyboard_key_4.651bbc97.png";